import { usePageMeta } from "../hooks/usePageMeta";
import { FadeIn } from "../components/site/FadeIn";
import { SectionHeading } from "../components/site/SectionHeading";
import { StatTile } from "../components/site/StatTile";
import { PersonCard } from "../components/site/PersonCard";
import { RESEARCH_QUESTIONS } from "../data/config";
import { LAB_STATS, LAB_DOES, PEOPLE, PEOPLE_NOTE, RECRUITING_BLURB, STUDENT_AWARDS } from "../data/lab";

export default function Lab() {
  usePageMeta(
    "Embedded Interaction Lab — IIT Guwahati",
    "Doctoral and Master's supervision in immersive learning and interaction design. Three topics currently open."
  );
  return (
    <div data-testid="lab-page">
      <section className="section">
        <div className="container-site">
          <FadeIn>
            <h1 className="text-h1 mb-6" style={{ color: "var(--navy-700)" }}>Embedded Interaction Lab</h1>
            <p className="body-lg measure mb-12">
              Founded in 2012 at IIT Guwahati, and the home of every funded project on this site. Two doctoral students have graduated from it, three are in progress, and fifteen Master's and thirty undergraduate theses have been completed here.
            </p>
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {LAB_STATS.map((s) => (
              <StatTile key={s.label} value={s.value} label={s.label} />
            ))}
          </div>
        </div>
      </section>

      <section className="section" style={{ background: "var(--surface-alt)" }}>
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="How it works" title="What the lab does" />
          </FadeIn>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {LAB_DOES.map((c) => (
              <FadeIn key={c.title}>
                <div className="h-full bg-white p-6" style={{ border: "1px solid var(--border-default)", borderRadius: 10 }}>
                  <h3 className="text-h4 mb-3">{c.title}</h3>
                  <p className="body-sm m-0">{c.body}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      <section className="section">
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="People" title="Students and researchers" />
          </FadeIn>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {PEOPLE.map((p) => (
              <FadeIn key={p.name}>
                <PersonCard person={p} />
              </FadeIn>
            ))}
          </div>
          <p className="body-sm mt-8 measure" style={{ color: "var(--ink-500)" }}>{PEOPLE_NOTE}</p>
        </div>
      </section>

      <section className="section" style={{ background: "var(--navy-100)" }} id="topics">
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="Recruiting" title="Three doctoral topics, currently open" />
            <p className="body-lg measure mb-10">{RECRUITING_BLURB}</p>
          </FadeIn>
          <ol className="m-0 p-0 flex flex-col" data-testid="doctoral-topics">
            {RESEARCH_QUESTIONS.map((q) => (
              <FadeIn key={q.number} as="li" className="flex flex-col md:flex-row gap-2 md:gap-8 py-6" style={{ borderBottom: "1px solid var(--border-default)", listStyle: "none" }}>
                <span className="shrink-0 font-semibold" style={{ color: "var(--accent-teal)", fontSize: 22 }}>{q.number}</span>
                <div>
                  <h3 className="text-h4 m-0 mb-2">{q.title}</h3>
                  <p className="body-default m-0 measure">{q.recruiting}</p>
                </div>
              </FadeIn>
            ))}
          </ol>
        </div>
      </section>

      <section className="section">
        <div className="container-site">
          <FadeIn>
            <SectionHeading eyebrow="Recognition" title="Student awards" />
          </FadeIn>
          <ul className="m-0 p-0">
            {STUDENT_AWARDS.map((a) => (
              <li key={a} className="body-default py-3" style={{ borderBottom: "1px solid var(--border-default)", listStyle: "none" }}>
                {a}
              </li>
            ))}
          </ul>
        </div>
      </section>
    </div>
  );
}
